import { useCallback, useState } from 'react';
export var useTabs = function (tabDefinitions) {
    var index = tabDefinitions.map(function (item) { return item.default; }).indexOf(true);
    var initialValue = index === -1 ? 0 : index;
    var _a = useState(initialValue), activeTab = _a[0], setActiveTab = _a[1];
    var onTabSwitch = useCallback(function (value) {
        setActiveTab(value);
    }, []);
    return { activeTab: activeTab, onTabSwitch: onTabSwitch };
};
